import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  transferHistory: {
    padding: "1.25em",
    border: "1px solid #286796",
    margin: "1.2em",
    borderRadius: "1em"
  },
  accordionReverse: {
    '&> div':{
      display: "flex",
      flexDirection: "column-reverse",
    }
  },
  }))

export default useStyles
